import { useCallback } from 'react';

import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import {
  StyledImageContainer, StyledSharedAsset, StyledList, StyledTextArea, StyledNextButton
} from '../../Interactive/WorksheetActivity/useStyles';

const NEXT_BUTTON_TEXT = 'Next';
export const I_AM_GOOD_AT = 'iAmGoodAt';

export const WhatYoureGoodAt = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <StyledImageContainer>
      <StyledSharedAsset
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise5.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </StyledImageContainer>
  );

  return (
    <ExercisePage
      caption="Exercise"
      title="What you&apos;re good at &#127942;"
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(I_AM_GOOD_AT)}
      onNext={onNextHandler}
    >
      <Text size={isMobile ? 'lg' : 'sm'} bold>Ask yourself:</Text>
      <StyledList>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What do people ask my advice on?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What do people praise me for?</Text>
        </li>
        <li>
          <Text size={isMobile ? 'lg' : 'sm'}>What activities come most naturally to me?</Text>
        </li>
      </StyledList>
      <StyledTextArea
        placeholder="I am good at..."
        text={getStorageValue(I_AM_GOOD_AT)}
        onChangeHandler={(e) => setStorageValue(I_AM_GOOD_AT, e.target.value)}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <StyledNextButton
        className="buttonRight"
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(I_AM_GOOD_AT)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

WhatYoureGoodAt.propTypes = {
  onNext: PropTypes.func
};

WhatYoureGoodAt.defaultProps = {
  onNext: () => {}
};

export default WhatYoureGoodAt;
